<div id="myModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content ">
      <span class="close" (click)="closePopUp()" >
        &times;
      </span>
      <p class="success user-msg" [innerHTML]="responseMessage"> </p>
      <div class="text-center">
            you won't be able to claim your 3 month free membership if you skip this step.
        <a class="btn" (click)="closePopUp()" >
            Cancel
        </a>
        <a class="btn" (click)="continueCheck()" >
            continue
        </a>
      </div>
    </div>
  </div>